import { createRouter } from '@tanstack/react-router';
import { queryClient } from './app/queryClient';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Private data must not be prefetched into view without an explicit visit.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    /** Private safe page label for the top bar and document title. Never an entity name. */
    title?: string;
  }
}
